// extracted by mini-css-extract-plugin
export var infoItem = "_tf-2";
export var title = "_tf-0";
export var value = "_tf-1";